import { Injectable } from '@angular/core';
import { GetCountriesFilter } from '@aoe/client';
import { Observable } from 'rxjs';
import { CountryResponse } from '../interfaces/CountryResponse.interface';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class CountryService extends ApiService {

  getCountries(query?: GetCountriesFilter): Observable<CountryResponse> {
    return this.get<CountryResponse>(`country`, query);
  }

}
